import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useIntl } from "react-intl";
import locale from "antd/es/date-picker/locale/zh_CN";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const x = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

export default function TopPurchasedProducts({ data }) {
  const intl = useIntl();

  const { locale } = useIntl();
  const isArabic = locale === "ar";
  const customOptions = {
    responsive: true,
    scales: {
      x: {
        stacked: true,
        position: "bottom",
        ticks: {
          color: "black",
          font: { size: 12, family: "Arial" },
        },
        grid: {
          color: "rgba(0, 0, 0, 0)",
        },
      },
      y: {
        stacked: true,
        position: "right",
        ticks: {
          color: "black",
          font: { size: 12, family: "Arial" },
        },
        grid: {
          color: "rgba(0, 0, 0, 0)",
        },
      },
    },
    indexAxis: "x",
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    parsing: {
      xAxisKey: "month",
      yAxisKey: "value",
    },
  };
  const labels = [
    intl.formatMessage({
      id: "january",
    }),
    intl.formatMessage({
      id: "february",
    }),
    intl.formatMessage({
      id: "march",
    }),
    intl.formatMessage({
      id: "april",
    }),
    intl.formatMessage({
      id: "may",
    }),
    intl.formatMessage({
      id: "june",
    }),
    intl.formatMessage({
      id: "july",
    }),
    intl.formatMessage({
      id: "august",
    }),
    intl.formatMessage({
      id: "september",
    }),
    intl.formatMessage({
      id: "october",
    }),
    intl.formatMessage({
      id: "november",
    }),
    intl.formatMessage({
      id: "december",
    }),
  ];
  const colors = [
    "rgba(255, 99, 132, 0.8)",
    "rgba(123, 172, 210, 0.8)",
    "rgba(197, 224, 244, 0.8)",
    "rgba(14, 24, 171, 0.8)",
  ];
  const processItems = (data, x, colors) => {
    const tempStorage = {};

    x.forEach((e) => {
      if (data[e] && data[e].length > 0) {
        data[e].forEach((item, i) => {
          const monthIndex = parseInt(e) - 1;

          if (tempStorage[item.id]) {
            // Existing item, reverse, update, and reverse back
            let monthlyData = tempStorage[item.id].data;

            // Reverse for update
            isArabic && monthlyData.reverse();

            if (monthIndex >= 0 && monthIndex < 12) {
              monthlyData[monthIndex] += item.totalSold; // Apply update
            }

            // Reverse back after update
            isArabic && monthlyData.reverse();
          } else {
            // New item, create without reversing
            let monthlyData = new Array(12).fill(0);
            if (monthIndex >= 0 && monthIndex < 12) {
              monthlyData[11 - monthIndex] = item.totalSold;
            }

            tempStorage[item.id] = {
              label: item.name,
              id: item.id,
              borderRadius: 6,
              data: isArabic ? monthlyData : monthlyData.reverse(), // No need to reverse here
              backgroundColor: colors[i % colors.length],
            };
          }
        });
      }
    });

    // At this point, data arrays are not reversed
    const datasets = Object.values(tempStorage);
    return datasets;
  };
  const reversedLabels = labels.slice().reverse();
  const customData = {
    labels: isArabic ? reversedLabels : reversedLabels.reverse(),
    datasets: processItems(data, x, colors),
  };
  return (
    <div dir="ltr" style={{ height: "18rem" }} className="">
      <Bar options={customOptions} data={customData} />
    </div>
  );
}
